import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./Onboard.css";

const API_URL = process.env.REACT_APP_API_URL;

const Onboard = () => {
  const { playerId } = useParams();
  const [gift, setGift] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(""); // New error state
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!gift) {
      setError("Please enter your dream gift"); // show inline error
      return;
    }

    setError(""); // clear error
    setLoading(true);

    try {
      const res = await fetch(`${API_URL}/players/${playerId}/gift`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ gift }),
      });

      if (!res.ok) {
        const data = await res.json();
        setError(data.error || "Error submitting gift");
        setLoading(false);
        return;
      }

      setLoading(false);
      navigate(`/game/${playerId}`);
    } catch (err) {
      console.error("Error submitting gift:", err);
      setError("Something went wrong");
      setLoading(false);
    }
  };

  return (
    <div className="onboard-container">
      <h1 className="onboard-title">Welcome!</h1>
      <p className="onboard-subtitle">
        Enter your dream gift idea below - this will not be revealed until after your gift exchange
      </p>

      {/* Inline error */}
      {error && <p className="onboard-error">{error}</p>}

      {/* Gift input */}
      <input
        type="text"
        className="onboard-input"
        placeholder="Your dream gift"
        value={gift}
        onChange={(e) => setGift(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
      />

      <p className="onboard-subtitle">
        Enter your email to find out the other players' dream gifts!
      </p>

      {/* Optional email field */}
      <input
        type="email"
        className="onboard-input"
        placeholder="Email (optional)"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />


      <button
        className="onboard-button"
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? "Saving..." : "Continue"}
      </button>
    </div>
  );
};

export default Onboard;
